import { useUser } from '@clerk/clerk-react';

/**
 * Hook to get the current user's role from Clerk publicMetadata.
 *
 * Roles:
 * - admin: Can perform all actions (deploy, transfer, mint, etc.)
 * - viewer: Can only view data (read-only access)
 *
 * @returns {Object} { role, isAdmin, isViewer, isLoading }
 */
export const useUserRole = () => {
  const { user, isLoaded } = useUser();

  // While loading, don't assume any role (prevents flash of wrong UI)
  if (!isLoaded) {
    return {
      role: null,
      isAdmin: false,
      isViewer: false,
      isLoading: true,
    };
  }

  const role = user?.publicMetadata?.role || 'viewer';
  const isAdmin = role === 'admin';
  const isViewer = role === 'viewer' || !isAdmin;

  return {
    role,
    isAdmin,
    isViewer,
    isLoading: false,
  };
};

export default useUserRole;
